var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LoginBaseModel } from './login-base-model';
var FacebookLoginModel = /** @class */ (function (_super) {
    __extends(FacebookLoginModel, _super);
    function FacebookLoginModel(authToken) {
        var _this = _super.call(this) || this;
        _this.token = authToken;
        return _this;
    }
    FacebookLoginModel.toJSON = function (value) {
        return {
            access_token: value.token,
            version: value.version,
            group_invite_mode: value.groupInviteMode,
            group_invite_key: value.groupInviteKey,
            group_code_mode: value.groupCodeMode,
            group_code: value.groupCode
        };
    };
    return FacebookLoginModel;
}(LoginBaseModel));
export { FacebookLoginModel };
